// Libs
import classNames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
import { Box, Grid2, Stack, Typography } from '@mui/material';
// Components, Layouts, Pages
// Others
import { getFullName } from '~/utils/helper/common';
import { ItemTypeClient } from '~/utils/interface/client';
import { TextTooltip } from '~/components/common';
// Styles, images, icons
import styles from './ClientKanbanItem.module.scss';
import { icons } from '~/assets';

type Props = {
  item: ItemTypeClient;
};

const cx = classNames.bind(styles);

const ClientKanbanItem = (props: Props) => {
  //#region Destructuring Props
  const { item } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['common/base']);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Box id='clientKanbanItemComponent' className={cx('container')}>
      <Typography className={cx('title')}>
        {getFullName({ firstName: item.firstName, lastName: item.lastName })}
      </Typography>

      <Stack direction={'row'} spacing={2} alignItems={'center'}>
        <img className={cx('icon')} src={icons.commonIconEmail} alt={t('common_alt_img')} />

        <TextTooltip className={cx('value')} text={item.email} />
      </Stack>

      <Grid2 container direction={'row'} spacing={2} alignItems={'center'} marginTop={'18px'}>
        <Grid2 size={6}>
          <Stack direction={'row'} spacing={'6px'} alignItems={'center'}>
            <img className={cx('icon')} src={icons.commonIconPhone} alt={t('common_alt_img')} />

            <Typography className={cx('value')}>{item.phoneNumber}</Typography>
          </Stack>
        </Grid2>

        <Grid2 size={6}>
          <Stack direction={'row'} spacing={'6px'} alignItems={'center'}>
            <img className={cx('icon')} src={icons.commonIconUser} alt={t('common_alt_img')} />

            <TextTooltip
              className={cx('value')}
              text={getFullName({ firstName: item.firstNameContact, lastName: item.lastNameContact })}
            />
          </Stack>
        </Grid2>
      </Grid2>

      <Stack direction={'row'} spacing={2} alignItems={'center'} marginTop={4}>
        <img className={cx('icon')} src={icons.commonIconAddress} alt={t('common_alt_img')} />

        <TextTooltip className={cx('value')} text={item.address} />
      </Stack>
    </Box>
  );
};

export default ClientKanbanItem;
